import { render, staticRenderFns } from "./VmAccountStatus.vue?vue&type=template&id=53ae5830&"
import script from "./VmAccountStatus.vue?vue&type=script&lang=js&"
export * from "./VmAccountStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports